import React, { useRef } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { DeckMode } from 'common/deckMode'
import { useMaintenance } from 'hooks'
import BigNumber from 'bignumber.js'
import { getWearColour, pickHeatColour } from 'common/heatColours'
import { useCurrentDeckContext } from 'components/currentDeckContext/CurrentDeckContext'

const RowItem = ({
  kits,
  col,
  materialSelected,
  mode,
  scale,
  maintenance,
  heatMapData,
  selected,
  onClick,
  type,
  inMaintenancePage,
    maintenanceView
}) => {
  const ref = useRef(null)

  const theme = useTheme()
  const { actions, getAction } = useMaintenance()
  const interactionColour = '#1441F5'
  const emptyColour = theme.palette.primary.dark

  const { currentMaintenanceView } = useCurrentDeckContext()
  if (!col) {
    return null
  }

  const isSelected =
    selected.filter(
      (s) =>
        s.MaterialNumber == col?.MaterialNumber &&
        s.Position?.Column === col?.Position?.Column &&
        s.Position?.Row === col?.Position?.Row
    ).length > 0
  const isMaterialSelected = materialSelected === col?.MaterialNumber
  const kit = kits.find((k) => k.MaterialNumber === col.MaterialNumber)

  const panelSize = kit?.Size
 let colour =
     isSelected || isMaterialSelected
       ? interactionColour
       : currentMaintenanceView !== 'layout' && inMaintenancePage && (mode !== DeckMode.default || type !== 'report')
       ? emptyColour
       : mode.includes(DeckMode.maintenance) && currentMaintenanceView !== 'layout'
       ? emptyColour
       : kit?.Colour ?? emptyColour

  const height = `${new BigNumber(panelSize?.Height ?? 1).multipliedBy(scale).toNumber()}em`
  const width = `${new BigNumber(panelSize?.Width ?? 1).multipliedBy(scale).toNumber()}em`

  let maintenanceAction = null
  let detailValue = null
  let isWearMeasurement = false

  //if in Maintenance mode, change the colours
   if (
      maintenance &&
      ((currentMaintenanceView && inMaintenancePage) ||
        (mode.includes(DeckMode.maintenance) && (type === 'report' || !isSelected)))
    ) {
    const column = new BigNumber(col.Position.Column)
    const row = new BigNumber(col.Position.Row)
    const detail = maintenance?.Details?.find(
      (d) => column.isEqualTo(d.Panel?.Position.Column) && row.isEqualTo(d.Panel?.Position.Row)
    )


    if (detail) {
      maintenanceAction = getAction(detail.HistoryAction)
      if (
        (mode === DeckMode.maintenance && maintenanceAction.id === actions.NoChange.id) ||
        (mode === DeckMode.preMaintenance &&
          (((detail.WorkingDepth || detail.WorkingDepth === 0) &&
            (detail.ApertureWidth || detail.ApertureWidth === 0)) ||
            (detail.DepthPercentage && detail.DepthPercentage !== 0))) ||
        (currentMaintenanceView && inMaintenancePage)
      ) {
        const previousColor = colour
        isWearMeasurement = detail.WearAppResponse === 'add-wear-action'
        colour = getWearColour(detail, theme)
        if (currentMaintenanceView === 'mm') {
          detailValue = detail.WorkingDepth ?? null
        } else if (currentMaintenanceView === '%') {
          detailValue = detail.DepthPercentage == null ? null : Math.round(Number(detail.DepthPercentage))
        } else if (currentMaintenanceView === 'action' || maintenanceView === 'action') {
          colour = emptyColour
        } else if (currentMaintenanceView === 'layout') {
          // colour = kit?.Colour ?? emptyColour
        }
        if ((detailValue == null && (currentMaintenanceView || maintenanceView) && inMaintenancePage) || !(currentMaintenanceView || maintenanceView)) {
          if (mode !== DeckMode.preMaintenance) colour = previousColor
          detailValue = detail.DepthPercentage ?? null
        } else if (currentMaintenanceView === 'action' || maintenanceView === 'action') {
          colour = emptyColour
        }
        if (detailValue == null && (currentMaintenanceView || maintenanceView) && inMaintenancePage) {
          detailValue = null
        }
        if ((currentMaintenanceView === '%' || currentMaintenanceView === 'mm') && detailValue == null) {
          colour = emptyColour
        }
      } else if (mode !== DeckMode.preMaintenance && maintenanceAction.id !== actions.NoChange.id) {
        if (
          (mode === DeckMode.maintenance && currentMaintenanceView === undefined) ||
          currentMaintenanceView !== 'action'
        ) {
          colour = currentMaintenanceView === 'layout' ? kit?.Colour : isSelected ? interactionColour : emptyColour
        } else {
          colour = 'white'
        }
      }
    }
  } else if (mode === DeckMode.heatMap) {
    const panelHeatData = heatMapData.Panels.find(
      (p) => p.Column === col?.Position?.Column && p.Row === col?.Position?.Row
    )

    const wearCount = new BigNumber(panelHeatData?.WearCount ?? 0)
    const total = heatMapData.Total.isEqualTo(0) ? new BigNumber(1) : heatMapData.Total
    const heatCount = total.minus(wearCount).dividedBy(total).times(100).toNumber()
    colour = pickHeatColour(heatCount, theme)
  }

  const backgroundColour = type === 'report' && mode === DeckMode.postMaintenance ? emptyColour : colour

  let child = (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: `${backgroundColour}`,
        border: '1px solid black',
        width: { width },
        height: { height },
        '&:hover': {
          backgroundColor: interactionColour
        }
      }}>
      {(type === 'report' ? mode === DeckMode.preMaintenance : currentMaintenanceView !== 'action') &&
        detailValue !== null && (
          <Typography
            color="black"
            sx={{
              fontSize: '8px'
            }}
            variant="body1">
            {detailValue}
          </Typography>
        )}

      {currentMaintenanceView === 'action' && maintenanceAction && !isWearMeasurement && (
        <img
          src={`${maintenanceAction.svg}`}
          style={{
            border: '1px solid black',
            height: `${height}`,
            width: `${width}`,
            verticalAlign: 'top'
          }}
        /> 
      )}
    </Box>
  )

  

  if (
    ((type === 'report' && [DeckMode.maintenance, DeckMode.default, DeckMode.postMaintenance].includes(mode)) || currentMaintenanceView === 'action') &&
    !isSelected &&
    maintenanceAction &&
    maintenanceAction.id !== actions.NoChange.id
  ) {
    child = (
      <img
        src={`${maintenanceAction.svg}`}
        style={{
          border: '1px solid black',
          height: `${height}`,
          width: `${width}`,
          verticalAlign: 'top'
        }}
      />
    )
  }

  return (
    <Box
      data-selection={isSelected}
      data-panel-type="DeckPanels"
      ref={ref}
      sx={{
        gridRow: `span ${panelSize?.Height ?? 1}`,
        gridColumn: `span ${panelSize?.Width ?? 1}`,
        width: { width },
        height: { height }
      }}
      data-item={JSON.stringify(col)}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        onClick(col, e)
        return true
      }}>
      {child}
    </Box>
  )
}

export const DeckRow = ({
  row,
  panels,
  materialSelected,
  kits,
  mode,
  scale,
  maintenance,
  heatMapData,
  rowIndex,
  onPanelClick,
  selected,
  type,
  inMaintenancePage,
  maintenanceView
}) => {
  return (
    <>
      {row.map((col, j) => {
        return (
          <RowItem
            key={`panel-${rowIndex}-${j}`}
            col={col}
            panels={panels}
            colIndex={j}
            heatMapData={heatMapData}
            kits={kits}
            maintenance={maintenance}
            materialSelected={materialSelected}
            mode={mode}
            onClick={onPanelClick}
            rowIndex={rowIndex}
            scale={scale}
            selected={selected}
            type={type}
            inMaintenancePage={inMaintenancePage}
              maintenanceView={maintenanceView}
          />
        )
      })}
    </>
  )
}
